import { useArticleInvoiceRoutes } from "./routes";
import { DateTimeViewer, GetDefaultIndex } from "../../components";
import { useGetArticleInvoiceCommonInfoQuery } from "../../features/articles/articleSubscriptionSlice";
import { Descriptions } from "antd";
import { ArticleInvoiceCommonInfoModel } from "../../entities/articles";

export { useArticleInvoiceRoutes };

export default GetDefaultIndex({
  title: "صورت‌حساب‌های مقالات",
  query: useGetArticleInvoiceCommonInfoQuery,
  extra: null,
  generalInfoPresentor: (info: ArticleInvoiceCommonInfoModel) =>
    info ? (
      <Descriptions size="small" column={{ xxl: 5, xl: 4, lg: 2, md: 2, sm: 1, xs: 1 }}>
        <Descriptions.Item label="تعداد کل" labelStyle={{ color: "gray" }}>
          {info.totalRecords}
        </Descriptions.Item>
        <Descriptions.Item label="در انتظار" labelStyle={{ color: "gray" }}>
          {info.totalPendingRecords}
        </Descriptions.Item>
        <Descriptions.Item label="پایان یافته" labelStyle={{ color: "gray" }}>
          {info.totalFinishedRecords}
        </Descriptions.Item>
        <Descriptions.Item label="ناموفق" labelStyle={{ color: "gray" }}>
          {info.totalFailedRecords}
        </Descriptions.Item>
        <Descriptions.Item label="آخرین صدور" labelStyle={{ color: "gray" }}>
          <DateTimeViewer value={info.lastIssuedAt} mode="distance" />
        </Descriptions.Item>
      </Descriptions>
    ) : null,
});
